import { createAction, props } from '@ngrx/store';

export const setIsAuthenticated = createAction(
    '[User State] Set Is Authenticated',
    props<{ isAuthenticated: boolean }>()
);

export const setLoggedInUser = createAction(
    '[User State] Set Logged In User',
    props<{ loggedInUser: Record<string, unknown> | null }>()
);

export const setUserRoleData = createAction(
    '[User State] Set User Role Data',
    props<{ userRoleData: Record<string, unknown> | null }>()
);

export const setUserStatus = createAction(
    '[User State] Set User Status',
    props<{ userStatus: 'Active' | 'Inactive' }>()
);

export const resetUserState = createAction('[User State] Reset User State');
